import { defineMessages } from 'react-intl';

import AgendaSummaryView from './AgendaSummaryBody';
import AgendaSummaryEdit from './AgendaSummaryEdit';
import { agendaSummarySchema } from './schema';

import iconSVG from '@plone/volto/icons/enterprise.svg';

defineMessages({
  appointmentsOfTheDay: {
    id: 'Appointments of the day',
    defaultMessage: 'Appointments of the day',
  },
});

const applyConfig = (config) => {
  config.blocks.blocksConfig.agendaSummaryBlock = {
    id: 'agendaSummaryBlock',
    title: 'Appointments of the day',
    group: 'organization',
    icon: iconSVG,
    view: AgendaSummaryView,
    edit: AgendaSummaryEdit,
    blockSchema: agendaSummarySchema,
    mostUsed: false,
    sidebarTab: 1,
    security: {
      addPermission: [],
      view: [],
    },
  };

  return config;
};

export default applyConfig;
